export default __webpack_public_path__ + "static/media/uploadEnglish.effc59cf.png";